module.exports = __webpack_public_path__ + "static/media/BwModelica-Medium.24113553.otf";